import {createGlobalState} from 'react-use';

type TMediaType = 'video' | 'image' | null;

interface IEventsMediaState {
    mediaSrc: string | null;
    mediaType: TMediaType;
}

export const useProductMediaState = createGlobalState<IEventsMediaState>({
    mediaSrc: null,
    mediaType: null,
});
